import { Component, OnInit, Input, Pipe, PipeTransform, ViewChild, QueryList, ViewChildren } from '@angular/core';

import { Location } from './location';
import { LocationService } from './locationService';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['../app.component.less', './location.component.less']
})
export class LocationComponent implements OnInit {
  @Input() location: Location;

  add1edit = true;
  add2edit = true;
  cityedit = true;
  countryedit = true;

  constructor(private locationservice: LocationService) { }

  ngOnInit() {
  }

  makeEdit(editable: boolean) {
    if (editable) {
      this.add1edit = false;
      this.add2edit = false;
      this.countryedit = false;
      this.cityedit = false;
    }
    else {
      this.add1edit = true;
      this.add2edit = true;
      this.countryedit = true;
      this.cityedit = true;
    }
  }

  updateLocation() {
    this.locationservice.updatelocation(this.location).subscribe(response => { });
    this.makeEdit(false);
  }

}

